import React from 'react';
import PropTypes from 'prop-types';

import { Container, Form, Button, Message, Header} from 'semantic-ui-react';

const ResetPassword = props => {
    let errorMessage;
    if (props.error) {
        const content = Array.isArray(props.error) ? props.error.map((e, index) => (<div key={index}>{`${e}`}</div>)) : props.error;
        errorMessage = (<Message error header="Password Reset Failed" content={content} />);
    }
    const {password, confirmPassword} = props.data;
    const passwordsMatch = password && confirmPassword && password === confirmPassword;
    return (
        <Container>
            <Form onSubmit={props.onSubmit} loading={props.loading} error>
                <Header as="h1" textAlign="center" content="Reset Password" />
                {errorMessage}                
                <Form.Field>
                    <input name="password" type="password" placeholder="Password" onChange={props.onChange} />
                </Form.Field>
                <Form.Field>
                    <input name="confirmPassword" type="password" placeholder="Confirm Password" onChange={props.onChange} />
                </Form.Field>
                <Form.Field inline>
                    <div style={{paddingLeft: 5}}>
                    <Header as="h4" content="Password Requirements:"/>
                    <ul>
                        <li><Header as="h4" content="Must be at least 8 characters"/></li>
                        <li><Header as="h4" content="Must contain at least one digit"/></li>
                        <li><Header as="h4" content="Must contain at least one uppercase and one lowercase character"/></li>
                    </ul>
                    </div>
                </Form.Field>
                <Button primary type="submit" disabled={!passwordsMatch}>RESET PASSWORD</Button>
            </Form>
        </Container>
    );
};

ResetPassword.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    data: PropTypes.object.isRequired,
    error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
    ])
};

export default ResetPassword;